/**
 * Configuration de l'API Backend
 * Utilise les variables d'environnement pour s'adapter à l'environnement (local/production)
 */

// Méthode robuste pour récupérer l'URL de l'API
const getApiBaseUrl = () => {
  // 1. Vérifier si process.env existe et contient REACT_APP_API_URL
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL) {
    console.log('✅ Using REACT_APP_API_URL from process.env:', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }
  
  // 2. En production, utiliser l'URL actuelle du site
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    const productionUrl = `${window.location.protocol}//${window.location.hostname}`;
    console.log('✅ Using production URL from window.location:', productionUrl);
    return productionUrl;
  }
  
  // 3. Fallback pour développement local
  console.warn('⚠️ Using fallback localhost:5000 - REACT_APP_API_URL not found');
  return 'http://localhost:5000';
};

const API_BASE_URL = getApiBaseUrl();

const API_CONFIG = {
  baseURL: API_BASE_URL,
  endpoints: {
    test: '/api/forms/test',
    submit: '/api/forms/submit',
    ownerLeadSubmit: '/api/owner-lead/submit',
  },
  timeout: 10000, // 10 secondes
};

// URLs complètes pour faciliter l'utilisation
export const API_URLS = {
  test: `${API_CONFIG.baseURL}${API_CONFIG.endpoints.test}`,
  submit: `${API_CONFIG.baseURL}${API_CONFIG.endpoints.submit}`,
  ownerLeadSubmit: `${API_CONFIG.baseURL}${API_CONFIG.endpoints.ownerLeadSubmit}`,
};

export default API_CONFIG;
